(() => {
  if (window.MalfiniCommerce) return;
  const script = document.querySelector('script[data-malfini-map-url]');
  let map, pending;
  const positions = new Set(['heart', 'front', 'back', 'right_arm', 'left_arm', 'small_front']);
  const api = {
    load() {
      if (!pending) pending = fetch(script.dataset.malfiniMapUrl).then(response => {
        if (!response.ok) throw new Error('Catalog mapping unavailable');
        return response.json();
      }).then(data => {
        if (!data.products) throw new Error('Catalog mapping invalid');
        data.variants = {};
        for (const [productId, product] of Object.entries(data.products)) {
          for (const [sku, variantId] of Object.entries(product.skus)) data.variants[String(variantId)] = {product: Number(productId), sku};
        }
        map = data;
        return api;
      });
      return pending;
    },
    product(id) { return map?.products[String(id)]; },
    variant(id) { return map?.variants[String(id)]; },
    validPositions(product, selected) {
      return Array.isArray(selected) && selected.length > 0 && new Set(selected).size === selected.length &&
        selected.every(position => positions.has(position)) && !product.quote &&
        (product.pants ? selected.length === 1 && selected[0] === 'small_front' : !selected.includes('small_front')) &&
        !(product.zip && selected.includes('front')) && !(selected.includes('heart') && selected.includes('front'));
    },
    saveSelection(selection) {
      const product = api.product(selection.productId), variant = api.variant(selection.variantId);
      if (!product || !variant || variant.product !== Number(selection.productId) || variant.sku !== selection.sku ||
          !Number.isInteger(selection.quantity) || selection.quantity < 1 || selection.quantity > 999 ||
          !['neutral', 'printed'].includes(selection.mode) ||
          (selection.mode === 'printed' && !api.validPositions(product, selection.positions))) throw new Error('Invalid garment selection');
      sessionStorage.setItem('tsp-malfini-selection-' + selection.productId, JSON.stringify({...selection, notes: String(selection.notes || '').slice(0, 2000), savedAt: Date.now()}));
    },
    selection(productId, sku) {
      try {
        const saved = JSON.parse(sessionStorage.getItem('tsp-malfini-selection-' + productId) || 'null');
        if (!saved || Number(saved.productId) !== Number(productId) || saved.sku !== sku || Date.now() - saved.savedAt > 1800000 ||
            !Number.isInteger(saved.quantity) || saved.quantity < 1 || saved.quantity > 999) return null;
        const product = api.product(productId);
        if (!product || (saved.mode === 'printed' && !api.validPositions(product, saved.positions))) return null;
        return saved;
      } catch { return null; }
    },
    clearSelection(productId) { try { sessionStorage.removeItem('tsp-malfini-selection-' + productId); } catch {} }
  };
  window.MalfiniCommerce = api;
  api.load().catch(() => {});
})();
